import { render, staticRenderFns } from "./GameUi.vue?vue&type=template&id=980d0e3e&scoped=true&"
import script from "./GameUi.vue?vue&type=script&lang=js&"
export * from "./GameUi.vue?vue&type=script&lang=js&"
import style0 from "./GameUi.vue?vue&type=style&index=0&id=980d0e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980d0e3e",
  null
  
)

export default component.exports